module.exports = __webpack_public_path__ + "img/balcony.1c3df06a.svg";